import { Helmet } from 'react-helmet-async';

const DEFAULT_OG =
  'https://www.arkothermfurnaces.com/continous_mesh_belt_roller_type.jpeg';

const SEO = ({
  title = 'Arkotherm Furnaces — ISO 9001 Certified Industrial Furnace Manufacturer | Amritsar & Ludhiana',
  description = 'Arkotherm Furnaces is an ISO 9001 Certified manufacturer of industrial furnaces and heat-treatment systems since 1960. Continuous Mesh Belt, Rotary Retort, Gas Carburizing, Annealing & Normalizing furnaces. Factories in Amritsar and Ludhiana.',
  path = '/',
  image = DEFAULT_OG,
  keywords = 'industrial furnace, heat treatment, continuous mesh belt furnace, rotary retort furnace, gas carburizing furnace, annealing furnace, normalizing furnace, muffle furnace, salt bath furnace, ISO 9001, furnace manufacturer Amritsar, furnace manufacturer Ludhiana, Arkotherm',
}) => {
  const url = `https://www.arkothermfurnaces.com${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Arkotherm Furnaces" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="googlebot" content="index, follow" />

      {/* JSON-LD Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Arkotherm Furnaces',
          alternateName: 'R.K Kohli & Sons',
          url: 'https://www.arkothermfurnaces.com',
          logo: 'https://www.arkothermfurnaces.com/arkotherm-logo.jpeg',
          foundingDate: '1960',
          description,
          address: {
            '@type': 'PostalAddress',
            streetAddress: '173, Mehta Road, Focal Point, Industrial Area',
            addressLocality: 'Amritsar',
            postalCode: '143006',
            addressRegion: 'Punjab',
            addressCountry: 'IN',
          },
          contactPoint: [
            {
              '@type': 'ContactPoint',
              telephone: '+91-62804-52690',
              contactType: 'sales',
              areaServed: 'IN',
              availableLanguage: ['English', 'Hindi', 'Punjabi'],
            },
            {
              '@type': 'ContactPoint',
              telephone: '+91-62390-19768',
              contactType: 'customer service',
              areaServed: 'IN',
            },
          ],
          email: 'rkkohli.sons@gmail.com',
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Industrial Furnace Range',
            itemListElement: [
              'Continuous Mesh Belt Hardening Furnace',
              'Rotary Retort Furnace',
              'Gas Carburizing Furnace',
              'Normalizing Furnace',
              'Muffle Furnace',
              'Salt Bath Furnace',
              'Annealing Furnace',
            ].map((p, i) => ({
              '@type': 'Offer',
              position: i + 1,
              itemOffered: { '@type': 'Product', name: p },
            })),
          },
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
